export default {
  state: {
    defaultData: {},
  },

  getters: {
    getDrivData(state) {
      return state.defaultData;
    },
  },

  mutations: {
    setDrivData(state, data) {
      const isNull = data === null;

      state.defaultData = {
        id: !isNull ? data.id : "",
        name: !isNull ? data.name : "",
        cpf: !isNull ? data.cpf : "",
        birth_date: !isNull ? data.birth_date : "",
        gender: !isNull ? data.gender : "",
        mother: !isNull ? data.mother : "",
        driver_licence: !isNull ? data.driver_licence : "",
        due_date: !isNull ? data.due_date : "",
        category: !isNull ? data.category : "",
        polyclinic_id: !isNull ? parseInt(data.polyclinic_id) : "",
      };
    },
  },

  actions: {
    changeDrivData(context, infos) {
      context.commit("setDrivData", infos);
    },
  },
};
